<template>
  <v-card class="mr-2 content-card" elevation="1" style="height: 100%; display: flex; flex-direction: column;">
    <v-card-title class="card-title pb-0">測試區（模擬檢查頁）</v-card-title>
    <v-card-text class="preview-content">

      <v-layout
          v-if="!getLoading"
          row
          wrap
          fill-height
          align-content-start
          class="examination-detail-page"
      >
        <v-flex xs12 class="pr-2 left" >
          <v-layout row wrap class="webrtc-container">
            <v-flex xs12 class="mb-3" fill-height>
              <PreviewFinding
                  v-if="templateType === 'finding' || templateType === 'static' || templateType === 'preface'"
                  :transI18n="transI18n"
                  :finding-id-filter="selectedId"
                  @refresh="$emit('refresh')">
              </PreviewFinding>
              <ExaminationFinding
                v-if="templateType === 'intervention'"
                :intervention-templates="interventionTemplates"
                :transI18n="transI18n"
                :intervention="selectedItem"
              ></ExaminationFinding>
            </v-flex>
          </v-layout>
        </v-flex>
        <CountingStartAnim
            v-if="isTimeCounting"
            @close="setTimeCounting(false)"
        ></CountingStartAnim>
        <FinishAnim
            v-if="isTimeFinish"
            @close="setTimeFinish(false)"
        ></FinishAnim>

        <v-dialog
            v-if="getExaminationData.examination"
            v-model="examinationFinishDialog"
            max-width="600px"
            persistent
        >
          <examination-finish-dialog
              :examination="getExaminationData.examination"
              :noFinding="noFinding"
              :hiddenParams="getStoreHiddenParameter"
              @close="setExaminationFinishDialog(false)"
              @endOfExam="setExaminationStatus()"
              @change="handleExaminationChange"
          ></examination-finish-dialog>
        </v-dialog>

        <v-dialog
            v-model="showIndication"
            persistent
            max-width="400px"
            v-if="examinationType !== 1"
        >
          <v-card>
            <v-card-text>
              <IndicationForm
                  :value="getExaminationData.examination.indication"
                  @change="checkIndication"
              />
              <div class="d-flex justify-end">
                <v-btn outline color="info" @click="showIndication = false"
                >{{ $t('common.close') }}
                </v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import common from '@/utils/common'
import CountingStartAnim from '@/components/examinations/CountingStartAnim.vue'
import FinishAnim from '@/components/examinations/FinishAnim.vue'
import VoiceActionControl from '@/components/VoiceActionControl.vue'
import Webrtc from '@/components/Webrtc.vue'
import ExaminationFinding from '@/components/ExaminationFinding.vue'
import ExaminationInfo from '@/components/ExaminationInfo.vue'
import ExaminationFilteringImages from '@/components/examinations/ExaminationFilteringImages.vue'
import ExaminationCaptureImageDialog from '@/components/examinations/ExaminationDetail/CaptureImageDialog.vue'
import ExaminationScreenshotGalleryDialog from '@/components/examinations/ExaminationDetail/ScreenshotGalleryDialog.vue'
import IconButtonWithTooltip from '@/components/IconButtonWithTooltip.vue'
import ExaminationFindingsFormLevelOne from '@/components/examinations/ExaminationFindingsFormLevelOne.vue'
import ExaminationFindingsFormLevelTwo from '@/components/examinations/ExaminationFindingsFormLevelTwo.vue'
import ExaminationBowelCleanseForms from '@/components/examinations/ExaminationBowelCleanseForms.vue'
import MicrophoneStatus from '@/components/examinations/MicrophoneStatus.vue'
import VoiceCommandDisplay from '@/components/examinations/VoiceCommandDisplay.vue'
import ConfirmDialogSmall from '@/components/ConfirmDialogSmall.vue'
import ExaminationNoFindingDialog from '@/components/examinations/ExaminationNoFindingDialog.vue'
import ExaminationFinishDialog from '@/components/examinations/ExaminationFinishDialog.vue'
import TimeInputsGroup from '@/components/TimeInputsGroup.vue'
import InsertionLevelInput from '@/components/bowelCleanseForms/InsertionLevelInput.vue'
import PreparationInput from '@/components/bowelCleanseForms/PreparationInput.vue'
import QuickCommend from '@/components/examinations/QuickCommend.vue'
import InsertionLengthInput from '@/components/bowelCleanseForms/InsertionLengthInput.vue'
import HorizontalCheckBoxes from '@/components/HorizontalCheckBoxes.vue'
import HorizontalRadio from '@/components/HorizontalRadio.vue'
import IndicationForm from '@/components/hpaForm/IndicationForm.vue'
import { findMatchI18n } from '@/utils/findMatchI18n'
import PreviewFinding from "@/views/admin/components/gastro-article/PreviewFinding.vue";
import PreviewIntervention from "@/views/admin/components/gastro-article/PreviewIntervention.vue";
import SectionEditor from "@/views/admin/components/gastro-article/SectionEditor.vue";
import _ from 'lodash';

export default {
  name: 'PreviewCard',
  props: {
    interventionTemplates: {
      type: Array,
      default: () => [],
    },
    templateType: {
      type: String,
      default: 'finding',
    },
    selectedItemName: {
      type: String,
      default: '',
    },
    selectedId: {
      type: Number,
    }
  },
  components: {
    PreviewFinding,
    PreviewIntervention,
    SectionEditor,
    TimeInputsGroup,
    VoiceActionControl,
    Webrtc,
    ExaminationFinding,
    ExaminationInfo,
    ExaminationFilteringImages,
    ExaminationCaptureImageDialog,
    ExaminationScreenshotGalleryDialog,
    IconButtonWithTooltip,
    ExaminationFindingsFormLevelOne,
    ExaminationFindingsFormLevelTwo,
    ExaminationBowelCleanseForms,
    ExaminationNoFindingDialog,
    ExaminationFinishDialog,
    ConfirmDialogSmall,
    CountingStartAnim,
    FinishAnim,
    InsertionLevelInput,
    PreparationInput,
    MicrophoneStatus,
    VoiceCommandDisplay,
    QuickCommend,
    InsertionLengthInput,
    HorizontalCheckBoxes,
    HorizontalRadio,
    IndicationForm,
  },

  data() {
    return {
      showIndication: false,
      flagShowScreenshotGalleryDialog: false,
      currentDevice: {audio: null, video: null},
      currentImageIndex: 0,
      imagesTabs: 'all',
      deleteDialog: false,
      deleteMessage: '',
      keyPressing: false,
      isRecord: false,
      flagTime: 0,
      cleansingLevel: {
        field: 'cleanScale',
        value: '',
      },
      isHandlingAnalysis: false,
    }
  },

  created() {
    this.$store.dispatch('examinations/fetchExaminationDetailAndOtherList', {
      examinationID: '6',
      accNo: 'A0000000006',
    })
    this.$store.dispatch('examinations/resetStoreHiddenParameterExamination')
    this.$store.dispatch('examinations/resetQuestionsList')
    this.$store.dispatch('examinations/setExaminationFinishDialog', false)
    this.$store.dispatch('examinations/setStoreHiddenParameter', {
      target: 'over',
      value: false,
    })
  },

  computed: {
    ...mapGetters('examinations', [
      'getDoctorList',
      'getTechnicalStaffList',
      'getExaminationData',
      'getLandmarkList',
      'getExaminationTypeList',
      'getPatient',
      'getIndicationList',
      'getQuestionsList',
      'getExaminationFinishDialog',
      'getStoreHiddenParameter',
      'getCleanScaleList',
      'getComplicationList',
      'getVoiceSelectionCommand',
      'getFlagShowCaptureImageDialog',
      'getCurrentCaptureImage'
    ]),
    ...mapGetters('interventions', [
      'getIntervention'
    ]),
    ...mapGetters(['getLoading', 'getIsAutoRecognize', 'getSetting']),
    isDemo() {
      return this.getSetting.demo
    },
    flagShowCaptureImageDialog() {
      return this.getFlagShowCaptureImageDialog
    },
    currentImage() {
      if (this.getAllImages) {
        return this.getAllImages[0]
      } else {
        return null
      }
    },
    cloTest() {
      return {
        check: Boolean(
            this.getExaminationInfo && +this.getExaminationInfo.cloTest
        ),
        field: 'cloLoca',
        value:
            (this.getExaminationInfo &&
                this.getExaminationInfo.cloTestLocations) ||
            null,
        options: {
          153: this.$t('right_sidebar.pylorus'),
          154: this.$t('right_sidebar.antrum'),
          155: this.$t('right_sidebar.lowbody'),
        },
      }
    },
    getExaminationInfo() {
      return this.getExaminationData.examination
    },
    getFindings() {
      return this.getExaminationData ? this.getExaminationData.findings : null
    },
    getFindingsLength() {
      return this.getFindings ? this.getFindings.length : 0
    },
    getAllImages() {
      if (this.getExaminationData && this.getExaminationData.all) {
        return this.getExaminationData.all.sort((a, b) => b.id - a.id)
      }
      return []
    },
    examinationID() {
      if (Number(this.$route.params.examinationID) != 0) {
        return this.$route.params.examinationID
      } else {
        if (this.getExaminationData != null) {
          return this.getExaminationData.examination.id
        }
      }
    },
    accNo() {
      return Number(this.$route.params.accNo) != 0
          ? this.$route.params.accNo
          : 0
    },
    examinationFinishDialog() {
      return this.getExaminationFinishDialog
    },
    isRecording() {
      return this.getStoreHiddenParameter.isRecording
    },
    isJudging() {
      return this.getStoreHiddenParameter.isJudging
    },
    isTimeCounting() {
      return this.getStoreHiddenParameter.isTimeCounting
    },
    isTimeFinish() {
      return this.getStoreHiddenParameter.isTimeFinish
    },
    examinationType() {
      // 1 => Gastroscopy, 2=> Colonoscopy
      return this.getExaminationData.examination.examination_typeID
    },
    insertionLevel() {
      return this.getExaminationData.examination.insertionLevel
    },
    insertionLength() {
      return this.getExaminationData.examination.insertionLength
    },
    complication() {
      return this.getExaminationData.examination.complication
    },
    noFinding() {
      return this.getFindings && this.getFindings.length <= 0
    },
    indicationKey() {
      return (
          this.getIndicationList &&
          this.getIndicationList.map((indi) => indi.value)
      )
    },
    selectedItem() {
      return {
        interventionId: this.selectedId,
        interventionName: this.selectedItemName,
        questions: this.getIntervention,
      }
    },
  },

  methods: {
    ...mapActions('examinations', [
      'updateExaminationStatus',
      'updateExaminationColumn',
      'addExaminationSedative',
      'deleteExaminationSedative',
      'addExaminationLocation',
      'deleteExaminationLocation',
      'updateExaminationLocationColumn',
      'setExaminationFinishDialog',
      'setStoreHiddenParameter',
      'setRecording',
      'setJudging',
      'setTimeCounting',
      'setTimeFinish',
    ]),
    ...mapActions('interventions', [
      'fetchIntervention'
    ]),
    ...mapActions('screenshots', [
      'setScreenshotGroup',
      'setScreenshotStatus',
      'deleteScreenshot',
    ]),
    ...mapMutations('examinations', [
      'setFlagShowCaptureImageDialog',
      'setCurrentCaptureImage',
      'setVoiceSelectionCommand',
    ]),
    transI18n(word) {
      return findMatchI18n(word)
    },
    examCommand(item) {
      const {state, value} = item
      switch (state) {
        case 'indication':
          this.indicationWebRtc(value)
          break
        case 'clo':
          this.setClo()
          break
        case 'cloLoca':
          this.setCloLocaInputId(value)
          break
        default:
          break
      }
    },
    indicationWebRtc(voiceInput) {
      switch (voiceInput) {
        case 'open':
          this.showIndication = true
          break
        case 'closed':
          this.showIndication = false
          break
        default:
          this.checkIndication(voiceInput)
          break
      }
    },
    checkIndication(voiceInput) {
      const indication =
          this.getExaminationData &&
          this.getExaminationData.examination &&
          this.getExaminationData.examination.indication
      const pattern = /\b9[a-g]\b/

      const inputletter = pattern.test(voiceInput)
          ? voiceInput.replace('9', '')
          : voiceInput
      const valid = this.indicationKey.includes(inputletter)

      if (valid) {
        let mainGroup = ['1', '2']
        let isMainSelect = mainGroup.includes(inputletter)
        let setData = isMainSelect
            ? indication.includes(inputletter) ? [] : [inputletter]
            : common.toggleItemInArr(
                indication.filter((i) => !mainGroup.includes(i)),
                inputletter
            )
        this.setExaminationColumn('indication', [...setData])
      }
    },
    setCurrentImage(item) {
      this.setFlagShowCaptureImageDialog(true)
      this.currentImage = this.getAllImages.find(i => i.id === item.id)
      this.currentImageIndex = this.getAllImages.findIndex((i) => i.id === item.id)

    },
    setClo() {
      const changeStatus = !this.cloTest.check
      this.setExaminationColumn('cloTest', changeStatus ? '1' : '0')
      if (!changeStatus) {
        this.setExaminationColumn('cloTestLocations', [])
      }
    },
    setColLoca(arr) {
      this.setExaminationColumn('cloTestLocations', arr)
      if (arr.length) {
        this.setExaminationColumn('cloTest', '1')
      }
    },
    setCloLocaInputId(voiceInput) {
      const {options: cloOptions, value: cloValues} = this.cloTest
      const options = Object.entries(cloOptions).reduce(
          (acc, [key, value]) => ({...acc, [value.toLowerCase()]: Number(key)}),
          {}
      )
      const targetId = options[voiceInput.toLowerCase()]
      if (targetId) {
        const result = common.toggleItemInArr(cloValues, targetId)
        this.setColLoca(result)
      }
    },
    isEmptyStr(str) {
      return str && str.trim().replace(' ', '') === '' ? true : false
    },
    setExaminationColumn(column, value) {
      let d = {
        id: this.examinationID,
        column: column,
        value: value,
      }
      this.updateExaminationColumn(d)
    },

    setInsertionLevelColumn(event) {
      this.setExaminationColumn('insertionLevel', event)
    },

    setInsertionLengthColumn(event) {
      this.setExaminationColumn('insertionLength', event)
    },

    setExaminationStatus() {
      this.setExaminationColumn('status', 2)
      this.$router.push({
        path: `/home`,
      })
    },
    setShowCaptureImageDialog(val) {
      this.showCaptureImageDialog = !!val
    },
    /* same as in report view, we can merge them later */
    toggleImgStatus(n, i, passStatus = -1) {
      const item =
          n === 'all' ? this.getAllImages[i] : this.getFindings[n].images[i]
      const currStatus = item.status
      let newStatus = !Number(currStatus) == true ? '1' : '0'
      if (passStatus > -1) {
        newStatus = passStatus
      }
      const imgID = item.id
      const findingID = item.findingID
      const landmarkID = item.landmarkID
      const obj = {
        imgID,
        newStatus,
        item,
        findingID,
        landmarkID,
      }

      if (item.findingID !== 0) {
        this.$store.dispatch(
            'examinations/updateScreenshotStatusInFinding',
            obj
        )
      }

      this.$store.dispatch('examinations/updateScreenshotStatusInAll', {
        ...obj,
        imgIndex: i,
      })
    },

    moveImgFromAllToFinding({id, newValue}) {
      const updateObj = {
        imgID: id,
        newValue,
      }

      this.$store.dispatch('examinations/moveImgFromAllToFinding', updateObj)
    },

    imgLandmarkChange({id, newValue}) {
      console.log('imgLandmarkChange', id, newValue)
      const updateObj = {
        imgID: id,
        newValue,
        page: 'e',
      }

      this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
    },

    handleSedative(action, event) {
      const examinationSedativeID = event ? event.id : null
      this[`${action}ExaminationSedative`]({
        examinationID: this.examinationID,
        examinationSedativeID,
      })
    },

    handleExaminationChange({column, field, event}) {
      if (typeof field != 'undefined') {
        this.setExaminationColumn(field, event)
      } else {
        this.setExaminationColumn(column, event)
      }
    },

    isEmptyObject: (obj) => common.isEmptyObject(obj),

    triggerRecordKey(eventName) {
      if (eventName == 'keydown') {
        this.flagTime = setTimeout(() => {
          this.isRecord = true
          this.handleTriggerKeyEvent(eventName, 88)
          this.keyPressing = true
          if (this.keyPressing !== false) {
            this.setRecording(true)
            this.setJudging(true)
          }
        }, 500)
      } else {
        const targetKeyCode = this.isRecord ? 88 : 90
        this.handleTriggerKeyEvent(eventName, targetKeyCode)
        clearTimeout(this.flagTime)
        this.keyPressing = false
        this.setRecording(false)
        if (this.isRecord) {
          let JUDGING_TIMOUT = 3500
          setTimeout(() => {
            this.setJudging(false)
            this.isRecord = false
          }, JUDGING_TIMOUT)
        }
      }
    },

    handleTriggerKeyEvent(eventName, keyCode) {
      var evObj = new KeyboardEvent(eventName, {
        keyCode: keyCode,
        which: keyCode,
      })
      // Chrome bug workaround:
      if (evObj.keyCode != keyCode) {
        evObj.keyCode = keyCode
        evObj.which = keyCode
      }
      window.dispatchEvent(evObj)
    },
    addCancelVoiceFocusListener() {
      const main = document.getElementsByTagName('main')[0]
      const _this = this

      main.addEventListener('click', () => {
        _this.setStoreHiddenParameter({
          target: 'focus',
          value: '',
        })
      })
    },
    // 短暫顯示 capture dialog 1.5秒
    brieflyCaptureImageDialog() {
      this.setFlagShowCaptureImageDialog(true)
      setTimeout(() => {
        if (
            this.flagShowScreenshotGalleryDialog
        ) {
          this.setFlagShowCaptureImageDialog(false)
        }
      }, 2000)
    },
  },

  watch: {
    selectedId(newId) {
      if (newId && this.templateType === 'intervention') {
        this.fetchIntervention(newId);
      }
    },
    getVoiceSelectionCommand(val, oldVal) {
      // 語音選圖功能
      if (!val || this.flagShowScreenshotGalleryDialog) return
      if (val.action === oldVal.action && val.target === oldVal.target) return
      if (val.action) {
        // console.log('watch getVoiceSelectionCommand', val)
        let findingSerial = 0
        let targetFinding = 0
        let targetLandmark = 0
        switch (val.action) {
            // case 'delete':
            //   const _index = this.getAllImages.length - parseInt(val.target)
            //   const targetImgId = this.getAllImages[_index].id
            //   this.deleteScreenshot(targetImgId)
            //   break
          case 'show me key images':
          case 'show to image':
          case 'show selected images':
            this.flagShowScreenshotGalleryDialog = true
            break
          case 'off':
            this.flagShowScreenshotGalleryDialog = false
            break
          case 'save':
            const _imgIndex = this.getAllImages.findIndex(
                (item) => item.id == this.currentImage.id
            )
            this.toggleImgStatus('all', _imgIndex, 1)
            this.brieflyCaptureImageDialog()
            break
          case 'save to finding':
            console.log('save to finding', this.flagShowScreenshotGalleryDialog)
            findingSerial = parseInt(val['target']) - 1
            targetFinding = this.getFindings.find(
                (item, index) => index == findingSerial
            )
            console.log('this.currentImage.id', this.currentImage.id)
            console.log('targetFinding', targetFinding.id)

            // param1 img.id, findingId
            this.moveImgFromAllToFinding({
              id: this.currentImage.id,
              newValue: targetFinding.id,
            })
            this.brieflyCaptureImageDialog()
            break
          case 'save to landmark':
            console.log('getLandmarkList', this.getLandmarkList)
            targetLandmark = this.getLandmarkList.find(
                (item) => item.landmark == val.target
            )
            // console.log('this.currentImage.id', this.currentImage.id)
            // console.log('targetLandmark', targetLandmark.id)
            this.imgLandmarkChange({
              id: this.currentImage.id,
              newValue: targetLandmark.id,
            })
            // param1 img.id, landmarkId
            this.brieflyCaptureImageDialog()
            break
          case 'save to finding landmark':
            findingSerial = parseInt(val['target']) - 1
            targetFinding = this.getFindings.find(
                (item, index) => index == findingSerial
            )
            targetLandmark = this.getLandmarkList.find(
                (item) => item.landmark == val.target2
            )
            // console.log({
            //   id: this.currentImage.id,
            //   newValue: targetFinding.id,
            // })
            // console.log({
            //   id: this.currentImage.id,
            //   newValue: targetLandmark.id,
            // })
            this.moveImgFromAllToFinding({
              id: this.currentImage.id,
              newValue: targetFinding.id,
            })
            this.imgLandmarkChange({
              id: this.currentImage.id,
              newValue: targetLandmark.id,
            })
            // param1 img.id, findingId
            // param1 img.id, landmarkId
            this.brieflyCaptureImageDialog()
            break
          default:
            break
        }
        this.setVoiceSelectionCommand({})
      }
    },
    getIsAutoRecognize(val) {
      if (!val) {
        this.isHandlingAnalysis = false
      }
    }
  }
};
</script>

<style lang="scss">
.insertion-length-input input[type='text'] {
  color: #5a81a3 !important;
}
</style>

<style lang="scss" scoped>
@import '@/styles/pages/page_examinationDetail.scss';
@import '@/styles/components/textInputsTextfield.scss';

.content-card {
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #eef1f6;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.06);
  /* Ensure the card behaves as a flex column that can constrain its content */
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-title {
  font-size: 1.08rem;
  font-weight: 600;
  color: #2f3542;
  padding: 14px 16px 6px;
  flex: 0 0 auto;
}

.preview-content {
  padding: 8px 16px 16px;
  color: #4a4f57;
  line-height: 1.6;
  /* Let content area take remaining height and scroll inside */
  flex: 1 1 auto;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
}


.examination-detail-page {
  user-select: none;
  /* fill remaining height and allow children to size correctly */
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Left column takes the available height */
.examination-detail-page > .left {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

/* Ensure nested layout doesn't break height chain */
.webrtc-container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.webrtc-container > .v-flex {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.examination-finding-sidebar {
  background-color: #000000; // color-code: background
  color: #98999a; //color-code: sidebar text color
  font-weight: bold;
}

.finish-bar {
  overflow: hidden;
  position: absolute;
  z-index: 10;
  width: 25%;
}

.hidden {
  visibility: hidden;
  position: absolute;
  top: 0;
}

hr {
  color: #252627; // color-code
}

.exam-col-container {
  padding: 1rem 0.5rem 0;
  background: rgba(#3b587d, 0.8);
  color: white;
  border-radius: 6px;
  overflow: hidden;
}

.alarm-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 3px;

  &__light {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: red;
    animation: showLight 1s ease infinite;
  }

  &__text {
    margin-left: 5px;
    margin-bottom: 0;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 2px;
    color: white;
  }
}

@keyframes showLight {
  0% {
    background-color: red;
  }
  25% {
    background-color: white;
  }
  50% {
    background-color: red;
  }
  75% {
    background-color: white;
  }
  100% {
    background-color: red;
  }
}
</style>
